var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 9.35824C18.29 9.35824 17.55 8.07824 18.45 6.50824C18.97 5.59824 18.66 4.43824 17.75 3.91824L16.02 2.92824C15.23 2.45824 14.21 2.73824 13.74 3.52824L13.63 3.71824C12.73 5.28824 11.25 5.28824 10.34 3.71824L10.23 3.52824C9.78 2.73824 8.76 2.45824 7.97 2.92824L6.24 3.91824C5.33 4.43824 5.02 5.60824 5.54 6.51824C6.45 8.07824 5.71 9.35824 3.9 9.35824C2.86 9.35824 2 10.2082 2 11.2582V13.0182C2 14.0582 2.85 14.9182 3.9 14.9182C5.71 14.9182 6.45 16.1982 5.54 17.7682C5.02 18.6782 5.33 19.8382 6.24 20.3582L7.97 21.3482C8.76 21.8182 9.78 21.5382 10.25 20.7482L10.36 20.5582C11.26 18.9882 12.74 18.9882 13.65 20.5582L13.76 20.7482C14.23 21.5382 15.25 21.8182 16.04 21.3482L17.77 20.3582C18.68 19.8382 18.99 18.6682 18.47 17.7682C17.56 16.1982 18.3 14.9182 20.11 14.9182C21.15 14.9182 22.01 14.0682 22.01 13.0182V11.2582C22 10.2182 21.15 9.35824 20.1 9.35824ZM12 15.3882C10.21 15.3882 8.75 13.9282 8.75 12.1382C8.75 10.3482 10.21 8.88824 12 8.88824C13.79 8.88824 15.25 10.3482 15.25 12.1382C15.25 13.9282 13.79 15.3882 12 15.3882Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.58ac66b5ceeb6546e9d6902f52a8c2d5.svg";
export { ForwardRef as ReactComponent };